module.exports = __webpack_public_path__ + "static/media/ODS17.8e10ca54.jpg";